interface ProgressIndicatorProps {
  currentStep: number;
}

const ProgressIndicator = ({ currentStep }: ProgressIndicatorProps) => {
  const steps = [
    { id: 'step_1', number: 1, label: 'Review' },
    { id: 'step_2', number: 2, label: 'Payment' },
    { id: 'step_3', number: 3, label: 'Complete' },
  ];

  return (
    <div data-component-id="src/app/checkout/components/ProgressIndicator.tsx:13:4" data-component-path="src/app/checkout/components/ProgressIndicator.tsx" data-component-line="13" data-component-end-line="43" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20gap-4%20mb-12%22%7D" className="flex items-center justify-center gap-4 mb-12">
      {steps.map((step, index) => (
        <div data-component-id="src/app/checkout/components/ProgressIndicator.tsx:15:8" data-component-path="src/app/checkout/components/ProgressIndicator.tsx" data-component-line="15" data-component-end-line="41" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%22%7D" key={step.id} className="flex items-center">
          <div data-component-id="src/app/checkout/components/ProgressIndicator.tsx:16:10" data-component-path="src/app/checkout/components/ProgressIndicator.tsx" data-component-line="16" data-component-end-line="33" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%22%7D" className="flex flex-col items-center">
            <div data-component-id="src/app/checkout/components/ProgressIndicator.tsx:17:12" data-component-path="src/app/checkout/components/ProgressIndicator.tsx" data-component-line="17" data-component-end-line="25" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              className={`w-12 h-12 rounded-full flex items-center justify-center font-bold transition-all ${
                currentStep >= step.number
                  ? 'bg-secondary text-secondary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}
            >
              {step.number}
            </div>
            <span data-component-id="src/app/checkout/components/ProgressIndicator.tsx:26:12" data-component-path="src/app/checkout/components/ProgressIndicator.tsx" data-component-line="26" data-component-end-line="32" data-component-file="ProgressIndicator.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`text-xs mt-2 font-medium ${
                currentStep >= step.number ? 'text-foreground' : 'text-muted-foreground'
              }`}
            >
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && (
            <div data-component-id="src/app/checkout/components/ProgressIndicator.tsx:35:12" data-component-path="src/app/checkout/components/ProgressIndicator.tsx" data-component-line="35" data-component-end-line="39" data-component-file="ProgressIndicator.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              className={`w-16 h-1 mx-2 rounded-full transition-all ${
                currentStep > step.number ? 'bg-secondary' : 'bg-muted'
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ProgressIndicator;
